import { VerticalProductCard } from "@shared/ui.components";
import type {
  MultipleProductCard,
  SingularProductCard,
  MultipleProductCardVariant,
  VariantType
} from "@shared/graphql.types";

import { ShadeSelectorDrawer } from "./ShadeSelectorDrawer";
import { useProductCard } from "./hooks/useProductCard";
import type { ProductCardTrackingPayload } from "./types";

interface ProductCardWrapperProps {
  productCard: SingularProductCard | MultipleProductCard;
  location: string;
  enableShadeSelector?: boolean;
  enableButton?: boolean;
  styles?: {
    variant?: "standard" | "carousel";
    buttonVariant?: "primary" | "secondary";
  };
  addToBasketOptions?: {
    afterAdd?: (variant: VariantType) => void;
    beforeAdd?: () => void;
  };
  onClickOptions?: {
    productClickedTrackingPayload?: ProductCardTrackingPayload;
    productCardClick?: () => void;
    disableLink?: boolean;
  };
  shouldTrackProductImpression?: boolean;
}

export const ProductCardWrapper = ({
  productCard,
  location,
  onClickOptions,
  styles: { variant, buttonVariant } = {},
  enableShadeSelector = true,
  enableButton = true,
  addToBasketOptions,
  shouldTrackProductImpression = true
}: ProductCardWrapperProps) => {
  const {
    productCardData,
    activeVariant,
    isShadeSelectorOpen,
    handlers,
    shouldRenderShadeSelector,
    inViewRef
  } = useProductCard(productCard, {
    location,
    addToBasketOptions,
    productClickedTrackingPayload:
      onClickOptions?.productClickedTrackingPayload,
    enableShadeSelector,
    productCardClick: onClickOptions?.productCardClick,
    shouldTrackProductImpression
  });

  return (
    <>
      {shouldRenderShadeSelector && (
        <ShadeSelectorDrawer
          product={productCard as MultipleProductCard}
          activeVariant={activeVariant as MultipleProductCardVariant}
          isOpen={isShadeSelectorOpen}
          onClose={handlers.closeShadeSelector}
          onShadeSelect={handlers.selectShade}
          resultId={onClickOptions?.productClickedTrackingPayload?.resultId}
          location={location}
          onATB={handlers.addToBasket}
        />
      )}

      <VerticalProductCard
        variant={variant ?? "standard"}
        buttonVariant={buttonVariant ?? "primary"}
        product={productCardData}
        onCardClick={handlers.onCardClick}
        onButtonClick={enableButton ? handlers.addToBasket : undefined}
        onShadeSelectorClick={handlers?.onShadeSelectorClick}
        onWishlistToggle={handlers.toggleWishlist}
        disableLink={onClickOptions?.disableLink}
        ref={inViewRef}
      />
    </>
  );
};
